/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_AloneInputs */

const en_us2_body_assessment_cue_alone = /** @type {(inputs: Body_Assessment_Cue_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Be the only person in the photo.`)
};

const pt_br2_body_assessment_cue_alone = /** @type {(inputs: Body_Assessment_Cue_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fique sozinho na foto.`)
};

const es_419_body_assessment_cue_alone = /** @type {(inputs: Body_Assessment_Cue_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que solo estés tú en la foto.`)
};

const pt_pt2_body_assessment_cue_alone = /** @type {(inputs: Body_Assessment_Cue_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fica sozinho na foto.`)
};

const fr_fr2_body_assessment_cue_alone = /** @type {(inputs: Body_Assessment_Cue_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personne d'autre que toi sur la photo.`)
};

const de_de2_body_assessment_cue_alone = /** @type {(inputs: Body_Assessment_Cue_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei allein auf dem Foto.`)
};

const it_it2_body_assessment_cue_alone = /** @type {(inputs: Body_Assessment_Cue_AloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devi essere l'unica persona nella foto.`)
};

/**
* | output |
* | --- |
* | "Be the only person in the photo." |
*
* @param {Body_Assessment_Cue_AloneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_alone = /** @type {((inputs?: Body_Assessment_Cue_AloneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_AloneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_alone(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_alone(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_alone(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_alone(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_alone(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_alone(inputs)
	return en_us2_body_assessment_cue_alone(inputs)
});
export { body_assessment_cue_alone as "body-assessment.cue.alone" }